import { render, staticRenderFns } from "./ExcesoVelocidad.vue?vue&type=template&id=2b2bce6c&"
import script from "./ExcesoVelocidad.vue?vue&type=script&lang=ts&"
export * from "./ExcesoVelocidad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports